<template>
   <div class="update-adaptive-game-update-MCQ-element container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row margin-left-1Point6Perc">
                <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
                      {{getCurrentlySelectedCourseObj.CourseTitle}}
                </div>    
                <div class="col-md-5 col-lg-5">
                  <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="udpateCloseUpdateElementOverlay($event,false)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
                  <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
                      {{lessonObj.Title}}
                  </div>    
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                          <input type="text" class="form-control" v-model="MCQTitleValue" :maxlength="titleMaxLength">
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Duration
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12">
                            <input type="text" class="form-control" v-model="MCQDurationValue" placeholder="MM:SS">
                        </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Question Type
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="QuestionTypeValue" disabled>
                        <option value=0>Single Answer</option>
                        <option value=1>Multiple Answers</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Question Text
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <textarea class="form-control" rows="5" v-model="MCQQuestionText" maxlength="1024"></textarea>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px" v-if="!addIntroPara">
                </div>
                <div class="col-md-4 col-lg-4" v-if="!addIntroPara">
                  <div class="form-group">
                    <div class="col-sm-12 cursor-pointer" @click="showIntroPara($event,true)">
                      + Add Introductory Paragraph
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1" v-if="!addIntroPara">
                </div> 
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px" v-if="addIntroPara">
                 Introductory Paragraph 
                </div>
                <div class="col-md-4 col-lg-4" v-if="addIntroPara">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <textarea class="form-control" rows="5" v-model="MCQIntroParagraph"></textarea>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1 text-align-left padding-left-0px font-size-12px cursor-pointer" v-if="addIntroPara" @click="showIntroPara($event,false)">
                  Remove
                </div>   
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Video Url
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                      <div class="col-sm-12">
                          <!-- <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_360" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control> -->
                        <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_Auto" :disableInputBox="false" @updatedValue="updateVideoQualityValue"></video-quality-control>
                        <!-- <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_720" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control> -->
                      </div>
                    </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                </div>
                <div class="col-md-4 col-lg-4">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Explanation
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <tinymce id="d1" v-model="MCQExplanationValue"></tinymce>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2">
                </div>  
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="checkbox">
                      <label v-bind:class="{'cursor-default': QuestionTypeValue === 1}"><input type="checkbox" value="true" v-model="MCQDoNotShowResult" disabled>Do not Show Result</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="checkbox" v-if="false">
                      <label><input type="checkbox" value="true" v-model="MCQIncludeInProgress">Include In Progress</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>   
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="col-md-10 col-lg-10 border-top-1px-solid-grey">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>  
                <div class="col-md-10 col-lg-10">
                  <div class="form-group">
                      <div class="col-sm-12">
                        <update-mcq-option v-bind:selectedMCQType="QuestionTypeValue" v-bind:mcqBtnClicked="IsUpdateMCQBtnPressed" v-bind:MCQOptions="MCQOptions" v-bind:correctAnswer="MCQCorrectAnswer" @addOptions="addOptions" v-bind:elementObj="elementObj"></update-mcq-option>
                      </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>  
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="getMCQOption">Update MCQ</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="removeIntroParagraph"></confirmation-alert>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div> 
</template>
<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import UpdateMCQOption from '@/components/adaptive_game/Update-element/UpdateAdaptiveGameUpdateMCQOption'
import AlertBox from '@/components/AlertOverlay'
import { elementService } from '@/server-util/element-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import tinymce from 'vue-tinymce-editor'
import VideoQualityControl from '@/components/VideoQualityControl'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['lessonObj', 'ElementObj'],
  name: 'update-adaptive-game-update-MCQ-element',
  created () {
    this.setDefaultValue()
  },
  data: function () {
    return {
      constants: constants,
      disableInputBoxFor360And720: true,
      showAlertDialog: false,
      errorMsg: '',
      addIntroPara: false,
      showSpinner: false,
      videoUrlObj: {
        LowQualityVideoUrl: '',
        HDVideoUrl: '',
        VideoUrl: ''
      },
      elementObj: {
        ElementId: '',
        ModuleId: '',
        Title: '',
        Duration: '',
        Type: 3,
        Index: null,
        IncludeInProgress: false,
        IsPublished: false,
        MCQItem: {
          QuestionId: '',
          QuestionText: '',
          Explanation: '',
          ExplanationVideoUrl: '',
          ExplanationLowQualityVideoUrl: '',
          ExplanationHDVideoUrl: '',
          IntroParagraph: '',
          QuestionType: 0,
          QuestionNo: 1,
          CorrectAnswer: '',
          DoNotShowResult: true,
          Options: []
        }
      },
      isUpdateBtnPressed: false,
      correctOptionArr: [],
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      titleMaxLength: constants.Element_Title_Step_Max_Length
    }
  },
  components: {
    'alert-box': AlertBox,
    'update-mcq-option': UpdateMCQOption,
    'confirmation-alert': ConfirmationOverlay,
    'loader': Loader,
    'tinymce': tinymce,
    'video-quality-control': VideoQualityControl
  },
  methods: {
    removeIntroParagraph (value) {
      // AK: If user okay for removing intro paragraph then clear it and close it
      if (value) {
        this.showConfirmationBox = false
        this.elementObj.MCQItem.IntroParagraph = ''
        this.addIntroPara = false
      }
    },
    addOptions (value) {
      if (value) {
        var _this = this
        // AK:Assign to Option object which needs to pass
        this.elementObj.MCQItem.Options = this.$store.state.createMcqOptions
        setTimeout(function () {
          // AK: Get and Assign Correct Answers
          var optionArrLength = _this.elementObj.MCQItem.Options.length
          console.log('optionArrLength >> ' + optionArrLength)
          for (var i = 0; i < optionArrLength; i++) {
            var isCorrectAns = _this.elementObj.MCQItem.Options[i].IsSelected
            var optionNo = _this.elementObj.MCQItem.Options[i].OptionNo
            if (isCorrectAns) {
              _this.correctOptionArr.push(optionNo)
            }
          }
          _this.elementObj.MCQItem.CorrectAnswer = _this.correctOptionArr.join()
        }, 50)
        setTimeout(function () {
          _this.updateMCQElement()
        }, 100)
      } else {
        // AK: Reset flag to original in order to get watch event on isUpdateBtnPressed in (AddOption file)
        // Since for same value, event does not emit
        this.isUpdateBtnPressed = false
        console.log('ALL UPDATE MCQ CONDITIONS ARE NOT FULLFILLED.')
      }
    },
    getMCQOption (value) {
      // AK: As soon as user pressed create MCQ
      this.isUpdateBtnPressed = true
    },
    showIntroPara: function ($event, flagToUpdate) {
      if (flagToUpdate === false) {
        // AK: If user wants to remove para then ask first confirmation
        this.prefixString = 'Are you sure you want to '
        this.postString = 'remove Introductory Paragraph?'
        this.showConfirmationBox = true
      } else {
        this.addIntroPara = flagToUpdate
      }
    },
    udpateCloseUpdateElementOverlay: function (event) {
      var objToPass = {
        closeOverlay: true,
        refreshList: false,
        updatedObj: null
      }
      this.$emit('closeUpdateMCQOverlay', objToPass)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateMCQElement: function (event) {
      console.log('ALL Obj: ' + JSON.stringify(this.elementObj))
      var _this = this
      var storeObj = this.$store
      if (
        this.lessonObj.ModuleId !== undefined &&
        this.elementObj.ModuleId !== '' &&
        this.elementObj.ModuleId !== undefined
      ) {
        this.elementObj.MCQItem.ExplanationVideoUrl = this.elementObj.MCQItem.ExplanationVideoUrl !== '' ? this.elementObj.MCQItem.ExplanationVideoUrl.trim() : ''
        this.elementObj.MCQItem.ExplanationHDVideoUrl = this.elementObj.MCQItem.ExplanationHDVideoUrl !== '' ? this.elementObj.MCQItem.ExplanationHDVideoUrl.trim() : ''
        this.elementObj.MCQItem.ExplanationLowQualityVideoUrl = this.elementObj.MCQItem.ExplanationLowQualityVideoUrl !== '' ? this.elementObj.MCQItem.ExplanationLowQualityVideoUrl.trim() : ''
        _this.$store.state.isLoading = true
        const orgContent = dmAdminUtils.removeTFromUrls(_this.elementObj.MCQItem.Explanation)
        _this.elementObj.MCQItem.Explanation = orgContent
        // AK: If user selected Multiple Type then set DoNotShowResult flag to false
        if (this.QuestionTypeValue === constants.Question_Type.Multiple_Answers) {
          this.elementObj.MCQItem.DoNotShowResult = false
        }
        elementService
          .updateMCQElement(storeObj.state.access_token, _this.elementObj)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.createMcqOptions = []
              var objToPass = {
                closeOverlay: true,
                refreshList: true,
                updatedObj: responseObj.data
              }
              _this.$emit('closeUpdateMCQOverlay', objToPass)
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Reset flag to original in order to get watch event on isUpdateBtnPressed in (AddOption file)
              // Since for same value, event does not emit
              this.isUpdateBtnPressed = false
            }
          }, errorObj => {
            // AK: Hide spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            // AK: Reset flag to original in order to get watch event on isUpdateBtnPressed in (AddOption file)
            // Since for same value, event does not emit
            this.isUpdateBtnPressed = false
          })
      } else {
        console.log(
          'Selected ModuleId is NULL hence declined UPDATE MCQ ELEMENT OPERATION'
        )
      }
    },
    updateVideoQualityValue (value) {
      console.log('Emitted with: ', value)
      const videoUrl = value.videoUrl
      const currQualityType = value.currQualityType
      switch (parseInt(currQualityType)) {
        case parseInt(constants.Video_Quality.Q_360):
          console.log('360 ' + videoUrl)
          this.videoUrlObj.LowQualityVideoUrl = videoUrl
          this.elementObj.MCQItem.ExplanationLowQualityVideoUrl = videoUrl
          break
        default:
        case parseInt(constants.Video_Quality.Q_Auto):
          console.log('Auto ' + videoUrl)
          this.elementObj.MCQItem.ExplanationVideoUrl = videoUrl
          this.videoUrlObj.VideoUrl = videoUrl
          if (this.elementObj.MCQItem.ExplanationVideoUrl.trim().length === 0) {
            this.elementObj.MCQItem.ExplanationLowQualityVideoUrl = ''
            this.videoUrlObj.LowQualityVideoUrl = ''
            this.elementObj.MCQItem.ExplanationHDVideoUrl = ''
            this.videoUrlObj.HDVideoUrl = ''
            this.disableInputBoxFor360And720 = true
          } else {
            this.disableInputBoxFor360And720 = false
          }
          break
        case parseInt(constants.Video_Quality.Q_720):
          console.log('720 ' + videoUrl)
          this.elementObj.MCQItem.ExplanationHDVideoUrl = videoUrl
          this.videoUrlObj.HDVideoUrl = videoUrl
          break
      }
    },
    setDefaultValue: function () {
      this.elementObj.ModuleId = this.ElementObj.ModuleId
      this.elementObj.ElementId = this.ElementObj.ElementId
      this.elementObj.Index = this.ElementObj.Index
      this.elementObj.Title = this.ElementObj.Title
      this.elementObj.Duration = this.ElementObj.Duration
      this.elementObj.IncludeInProgress = this.ElementObj.IncludeInProgress
      this.elementObj.MCQItem.QuestionId = this.ElementObj.MCQItem.QuestionId
      this.elementObj.MCQItem.QuestionText = this.ElementObj.MCQItem.QuestionText
      this.elementObj.MCQItem.ExplanationVideoUrl = (this.ElementObj.MCQItem.ExplanationVideoUrl !== undefined && this.ElementObj.MCQItem.ExplanationVideoUrl !== null && this.ElementObj.MCQItem.ExplanationVideoUrl !== '') ? this.ElementObj.MCQItem.ExplanationVideoUrl : ''
      this.videoUrlObj.VideoUrl = this.elementObj.MCQItem.ExplanationVideoUrl
      this.disableInputBoxFor360And720 = this.elementObj.MCQItem.ExplanationVideoUrl.trim().length === 0
      this.elementObj.MCQItem.ExplanationHDVideoUrl = (this.ElementObj.MCQItem.ExplanationHDVideoUrl !== undefined && this.ElementObj.MCQItem.ExplanationHDVideoUrl !== null && this.ElementObj.MCQItem.ExplanationHDVideoUrl !== '') ? this.ElementObj.MCQItem.ExplanationHDVideoUrl : ''
      this.videoUrlObj.HDVideoUrl = this.elementObj.MCQItem.ExplanationHDVideoUrl
      this.elementObj.MCQItem.ExplanationLowQualityVideoUrl = (this.ElementObj.MCQItem.ExplanationLowQualityVideoUrl !== undefined && this.ElementObj.MCQItem.ExplanationLowQualityVideoUrl !== null && this.ElementObj.MCQItem.ExplanationLowQualityVideoUrl !== '') ? this.ElementObj.MCQItem.ExplanationLowQualityVideoUrl : ''
      this.videoUrlObj.LowQualityVideoUrl = this.elementObj.MCQItem.ExplanationLowQualityVideoUrl
      this.elementObj.MCQItem.IntroParagraph = this.ElementObj.MCQItem.IntroParagraph
      if (this.elementObj.MCQItem.IntroParagraph !== '' && this.elementObj.MCQItem.IntroParagraph !== null && this.elementObj.MCQItem.IntroParagraph !== undefined) {
        this.addIntroPara = true
      }
      this.elementObj.MCQItem.QuestionType = this.ElementObj.MCQItem.QuestionType
      this.elementObj.MCQItem.QuestionNo = this.ElementObj.MCQItem.QuestionNo
      this.elementObj.MCQItem.CorrectAnswer = this.ElementObj.MCQItem.CorrectAnswer
      this.elementObj.MCQItem.DoNotShowResult = true // this.ElementObj.MCQItem.DoNotShowResult
      this.elementObj.MCQItem.Options = this.ElementObj.MCQItem.Options
      var _this = this
      setTimeout(function () {
        _this.elementObj.MCQItem.Explanation = dmAdminUtils.updateUrls(_this.ElementObj.MCQItem.Explanation)
      }, 500)
      console.log(' Element Obj >>> ' + JSON.stringify(this.ElementObj))
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
      // AK: If user pressed cancel of confirmation then don't close paragraph
      this.addIntroPara = true
    }
  },
  computed: {
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    MCQExplanationValue: {
      get: function () {
        return this.elementObj.MCQItem.Explanation
      },
      set: function (newValue) {
        this.elementObj.MCQItem.Explanation = newValue
      }
    },
    MCQTitleValue: {
      get: function () {
        return this.elementObj.Title
      },
      set: function (newValue) {
        this.elementObj.Title = newValue
      }
    },
    MCQIndexValue: {
      get: function () {
        return this.elementObj.Index
      },
      set: function (newValue) {
        if (newValue.trim() !== '') {
          var isNonNumeric = /[^$,.\d]/
          var nonNumericResult = newValue.match(isNonNumeric)
          if (!nonNumericResult) {
            if (parseInt(newValue) >= 1000) {
              this.errorMsg = 'Index should be less than 1000.'
              this.showAlertDialog = true
              this.elementObj.Index = this.ElementObj.Index
            } else {
              this.elementObj.Index = parseInt(newValue)
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Index must be a positive numeric value.'
            this.elementObj.Index = this.ElementObj.Index
          }
        } else {
          this.elementObj.Index = null
        }
      }
    },
    MCQDurationValue: {
      get: function () {
        return this.elementObj.Duration
      },
      set: function (newValue) {
        this.elementObj.Duration = newValue
      }
    },
    MCQIncludeInProgress: {
      get: function () {
        return this.elementObj.IncludeInProgress
      },
      set: function (newValue) {
        this.elementObj.IncludeInProgress = newValue
      }
    },
    QuestionTypeValue: {
      get: function () {
        return this.elementObj.MCQItem.QuestionType
      },
      set: function (newValue) {
        this.elementObj.MCQItem.QuestionType = parseInt(newValue)
      }
    },
    MCQDoNotShowResult: {
      get: function () {
        return this.elementObj.MCQItem.DoNotShowResult
      },
      set: function (newValue) {
        this.elementObj.MCQItem.DoNotShowResult = newValue
      }
    },
    MCQIntroParagraph: {
      get: function () {
        return this.elementObj.MCQItem.IntroParagraph
      },
      set: function (newValue) {
        this.elementObj.MCQItem.IntroParagraph = newValue
      }
    },
    MCQQuestionText: {
      get: function () {
        return this.elementObj.MCQItem.QuestionText
      },
      set: function (newValue) {
        this.elementObj.MCQItem.QuestionText = newValue
      }
    },
    IsUpdateMCQBtnPressed: {
      get: function () {
        return this.isUpdateBtnPressed
      }
    },
    MCQOptions: {
      get: function () {
        return this.elementObj.MCQItem.Options
      }
    },
    MCQCorrectAnswer: {
      get: function () {
        return this.elementObj.MCQItem.CorrectAnswer
      }
    }
  }
}
</script>

<style scoped>
.cursor-default {
  cursor: default !important;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left !important;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.padding-right-0px{
  padding-right: 0px !important;
}
.padding-left-0px{
  padding-left: 0px !important;
}
.font-size-12px{
  font-size: 12px;
}
.border-1px-solid-grey {
  border: 1px solid #aaa;
}
.border-top-1px-solid-grey {
  border-top: 1px solid #dadada;
}
.border-bottom-1px-solid-grey {
  border-bottom: 1px solid #dadada;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
.border-red{
  border: 1px solid red; 
}
.padding-left-30px{
  padding-left:30px;
}
.font-size-12px{
  font-size:12px;
}
</style>


// WEBPACK FOOTER //
// src/components/adaptive_game/Update-element/UpdateAdaptiveGameUpdateMCQElement.vue